import { render, staticRenderFns } from "./reset-password-modal.vue?vue&type=template&id=5cfd1185&scoped=true&"
import script from "./reset-password-modal.vue?vue&type=script&lang=js&"
export * from "./reset-password-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd1185",
  null
  
)

export default component.exports